import idx from "idx"
import { toLowerCaseIfExists, logTool } from "@jsUtils"

const log = logTool()

/**
 * transform - manipulate data from the graphql query
 * @param {object} contentfulImageBanner
 * @returns {object}
 */
function transform(contentfulImageBanner) {
  log("banner.factory.transform()", contentfulImageBanner)

  const appearance = toLowerCaseIfExists(idx(contentfulImageBanner, _ => _.appearance))
  const eyebrow = idx(contentfulImageBanner, _ => _.eyebrow)
  const headline = idx(contentfulImageBanner, _ => _.headline)
  const hideGrid = idx(contentfulImageBanner, _ => _.hideGrid)
  const forceLeft = idx(contentfulImageBanner, _ => _.forceLeft)
  const image = idx(contentfulImageBanner, _ => _.image)
  const description = idx(contentfulImageBanner, _ => _.description.description)
  const buttonLabel = idx(contentfulImageBanner, _ => _.buttonLabel)
  const link = idx(contentfulImageBanner, _ => _.link)
  const theme = toLowerCaseIfExists(idx(contentfulImageBanner, _ => _.theme)) || "dark"
  const color = toLowerCaseIfExists(idx(contentfulImageBanner, _ => _.color)) || "fluro"

  return {
    appearance,
    eyebrow,
    headline,
    image,
    description,
    theme,
    hideGrid,
    forceLeft,
    color,
    buttonLabel,
    link
  }
}

export default { transform }
